import { render, staticRenderFns } from "./ConfigurationDashboardView.vue?vue&type=template&id=5fdf863c"
import script from "./ConfigurationDashboardView.vue?vue&type=script&lang=js"
export * from "./ConfigurationDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports